<template>
    <div class="article-grid-item">
        <div class="image">
            <ThLink v-bind="bind">
                <CmsImage
                    :data="data.image"
                    fit="cover"
                    :is-eager="hasEagerImage"
                />
            </ThLink>
        </div>

        <div class="description">
            <h2 class="title">
                <ThLink v-bind="bind">
                    {{ data.title }}
                </ThLink>
            </h2>

            <p class="description-p">
                <ThLink v-bind="bind">
                    {{ data.description }}
                </ThLink>
            </p>

            <ThButton
                :text-size="14"
                color="var(--slate)"
                type="link"
                v-bind="bind"
            >
                {{ data.link.text }}
            </ThButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import type { ArticleGridItemFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms'

import CmsImage from '@/components/cms/CmsImage.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'

const props = defineProps<{
    data: ArticleGridItemFragment
    hasEagerImage?: boolean
}>()

const bind = useCmsLink(toRef(() => props.data.link))
</script>

<style lang="scss" scoped>
.article-grid-item {
    width: 100%;
    margin: 0 0 40px;

    @include min-width(1024) {
        margin: 0 0 80px;
    }

    .image {
        width: 100%;
        height: 300px;
        margin: 0 0 20px;

        @include min-width(768) {
            height: 400px;
        }

        @include min-width(1024) {
            height: 240px;
        }
    }

    .description {
        width: 740px;
        max-width: 100%;
        margin: 0 auto;
        padding: 0 20px;

        @include min-width(640) {
            padding: 0 10px;
        }

        @include min-width(1024) {
            width: initial;
        }

        .title {
            font-family: $parcel-font-stack;
            font-size: 1.18rem;
            line-height: 1.4em;
            letter-spacing: 0.01em;
            margin: 0 0 20px;
        }

        .description-p {
            font-size: 1rem;
            line-height: 1.4em;
            color: $grey-500;
            margin: 0 0 20px;
        }
    }
}
</style>
